<template>
    <div class="container">
        <form class="form-horizontal col-md-6 offset-md-3 col-lg-8 offset-lg-2"
              role="form" @submit.prevent="reset">
            <div class="row">
                <div class="col-md-6 offset-md-3 col-lg-4 offset-lg-4 text-center">
                    <h2>Baseline<br>รีเซ็ตรหัสผ่าน</h2>
                    <hr>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 offset-md-3">
                    <div class="form-group has-danger">
                        <label class="sr-only" for="email">อีเมล</label>
                        <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                            <input type="text" name="email" class="form-control" id="email"
                                   v-model="form.email"
                                   placeholder="you@example.com"
                                   required autofocus>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="padding-top: 1rem">
                <div class="col-md-6 offset-md-3 text-center">
                    <button type="submit" class="btn btn-success btn-block" v-if="loading===false">
                        ขอรหัสผ่านใหม่
                    </button>
                    <b-button variant="success" block disabled v-else>
                        <b-spinner small type="grow"/>
                        กำลังโหลดข้อมูล...
                    </b-button>
                </div>
            </div>
            <div class="row" style="padding-top: 1rem">
                <div class="col-md-12 text-center">
                    <a class="btn btn-link" href="/login">เข้าสู่ระบบ</a>
                    |
                    <a class="btn btn-link" href="/">หน้าหลัก</a>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import Service from "../services/Service"

    export default {
        name: "ResetPassword",
        data() {
            return {
                loading: false,
                form: {
                    email: '',
                },
            }
        },
        created() {},
        computed: {
        },
        methods: {
            reset(evt) {
                this.loading = true;
                evt.preventDefault();
                Service.post("/password/reset", this.form)
                    .then(res => {
                        if (res.status === "success") {
                            this.$toasted.show(`ส่งคำขอสำเร็จ<br>โปรดเช็คอีเมล`, {
                                type: 'success',
                                icon: 'check',
                                iconPack: 'fontawesome',
                                duration: 5000
                            });
                            this.$router.push({ name: 'login'})
                        }else{
                            let message = `Validate Fails.<br>${res.result.join("<br>")}`;
                            this.$toasted.show(message, {
                                type: 'error',
                                icon: 'exclamation-circle',
                                iconPack: 'fontawesome',
                                duration: 5000
                            });
                        }
                        this.loading = false;
                    })
                    .catch(err => {
                        console.log(err.message)
                        this.$toasted.show("เกิดข้อผิดพลาด โปรดลองใหม่อรกครั้ง", {
                            type: 'error',
                            icon: 'exclamation-circle',
                            iconPack: 'fontawesome',
                            duration: 5000
                        });
                        this.loading = false;
                    });
            }
        }
    }
</script>

<style scoped>
    form {
        padding: 1.25rem;
        border: brown solid thin;
        background: azure;
        margin-top: 25vh;
    }
</style>